import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Box, Image, useUserColorMode } from '@bonusly/design-system';
import { useCurrentCompany } from '@bonusly/who-am-i';

import darkLogo from '../../../../assets/images/bonusly-logo-dark-mode.png';
import { useSeasonalLogo } from '../../../../components/seasonal/use-seasonal-logo';
import logo from '../../assets/images/bonusly-logo.png';
import { AppPath } from '../../config/router';

export const CompanyLogo: FC = () => {
	const company = useCurrentCompany();
	const { t } = useTranslation('vertical_navbar');
	const { logoUrl: seasonalLogo } = useSeasonalLogo();
	const { isDarkMode } = useUserColorMode();

	// Determine which logo to use: seasonal > company > default (with dark mode support)
	const logoConfig = useMemo(() => {
		// Priority: seasonal theme > company logo > bonusly logo (light/dark)
		const defaultLogo = isDarkMode ? darkLogo : logo;
		const logoSrc = seasonalLogo || company?.logo_url || defaultLogo;
		const logoAlt = seasonalLogo
			? t('admin_menu.company_logo', { name: 'Bonusly' })
			: company?.logo_url
				? t('admin_menu.company_logo', { name: company.name })
				: t('admin_menu.company_logo', { name: 'Bonusly' });

		return { logoSrc, logoAlt };
	}, [seasonalLogo, company?.logo_url, company?.name, t, isDarkMode]);

	return (
		<Box as={Link} id="primary-nav-logo" data-testid="company-logo" to={AppPath.Home} px={6} py={3.5} display="flex" justifyContent="center">
			<Image data-testid="logo-image" alt={logoConfig.logoAlt} objectFit="contain" src={logoConfig.logoSrc} maxH={20} />
		</Box>
	);
};
